<div class="content-container">
  <h2>Sobre el proyecto</h2>
  <div class="truck-bar">
    <img src="assets/img/left-truck.png" alt="truck sideways">
    <p>"Transporte Eléctrico de Carga: Análisis de los desafíos para su introducción en Uruguay"</p>
  </div>
  <ul class="content-list">
    <li *ngFor="let aboutEntry of aboutEntryList">
      <h3 (click)="changeEntry(aboutEntry)"
          [ngClass]="{'selected-title' : aboutEntry.status}">{{aboutEntry.title}}</h3>
      <p [ngClass]="[aboutEntry.status ? 'show-desc' : 'hide-desc', 'about-entry-description']"
         [innerHTML]="safeHtml(aboutEntry.description)"></p>
    </li>
  </ul>
</div>

<div class="fill-content"></div>

<div class="screen-bottom-positioning">
  <div class="blue-horizontal-line"></div>
  <app-footer class="footer"></app-footer>
</div>
